import styled from 'styled-components';

export const Container = styled.div`
  pointer-events: all;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, ${props => props.alpha});
  z-index: 999;
  transition: 0s all ease-in-out;
`;

export const ContainerInner = styled.div`
  max-width: 1180px;
  padding: 85px 10px;
  margin: auto;
`;

export const Header = styled.div`
  font-size: 16px;
`;

export const Content = styled.div``;
